import { Link } from "react-router-dom";
import Navigation from "../components/feature/Navigation";
import Footer from "../components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navigation />
      <main className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="text-center">
          <h1 className="text-8xl md:text-9xl font-bold text-emerald-600 mb-4">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Page Not Available
          </h2>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>
          <Link
            to="/"
            className="inline-flex items-center px-8 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-all duration-300 shadow-lg shadow-emerald-600/30"
          >
            <i className="ri-home-line mr-2"></i>
            Back to Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
